.panel {
  position: relative;
  min-width: 0;
  overflow: hidden;
  background:
    linear-gradient(rgb(101 217 239 / .012) 1px, transparent 1px),
    var(--surface-1);
  background-size: 100% 24px;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: inset 0 1px rgb(255 255 255 / .018);
}

.panelHeader {
  min-height: 48px;
  padding: 10px 16px;
  border-bottom: 1px solid var(--border);
  background: linear-gradient(90deg, rgb(101 217 239 / .035), transparent 45%), #0c1218;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.panelTitleBlock { min-width: 0; }
.headingWithTip { min-width: 0; display: flex; align-items: center; gap: 7px; }
.panelTitle { margin: 0; color: var(--text-strong); font: 650 13px/1.35 var(--font-terminal); letter-spacing: -.015em; }
.panelTitle::before { content: '> '; color: var(--terminal-green); text-shadow: 0 0 8px rgb(117 230 164 / .25); }
.panelBody { padding: 16px; }

.pageHeader {
  min-height: 58px;
  margin-bottom: 18px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
}

.pageCopy { min-width: 0; max-width: 860px; }
.pageTitle { margin: 0; color: var(--text-strong); font: 680 24px/1.25 var(--font-terminal); letter-spacing: -.035em; }
.pageTitle::before { content: '~/ '; color: var(--terminal-cyan); font-weight: 500; text-shadow: 0 0 10px rgb(101 217 239 / .2); }
.pageActions { flex: none; display: flex; align-items: center; justify-content: flex-end; flex-wrap: wrap; gap: 7px; }

.button, .iconButton, .chip {
  min-height: 34px;
  padding: 0 11px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  background: #0d141a;
  color: var(--text);
  box-shadow: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  font: 620 11px/1 var(--font-terminal);
  white-space: nowrap;
  cursor: pointer;
  transition: border-color .12s ease, background .12s ease, color .12s ease;
}

.button:hover, .iconButton:hover, .chip:hover { border-color: var(--terminal-cyan); background: color-mix(in srgb, var(--terminal-cyan) 7%, var(--surface-2)); color: var(--text-strong); box-shadow: inset 0 0 16px rgb(101 217 239 / .025); }
.button:active, .iconButton:active { background: var(--surface-3); }
.buttonPrimary { border-color: color-mix(in srgb, var(--terminal-green) 70%, var(--border)); background: var(--terminal-green-dim); color: var(--terminal-green); box-shadow: inset 0 0 18px rgb(117 230 164 / .035); }
.buttonPrimary:hover { border-color: var(--terminal-green); background: color-mix(in srgb, var(--terminal-green) 16%, var(--surface-1)); color: #a8f5c6; }
.buttonDanger { color: var(--danger); }
.buttonDanger:hover { border-color: color-mix(in srgb, var(--danger) 42%, var(--border)); background: color-mix(in srgb, var(--danger) 9%, var(--surface-2)); }
.iconButton { width: 34px; padding: 0; }
.button:disabled, .iconButton:disabled, .chip:disabled { opacity: .42; cursor: not-allowed; }

.chip { min-height: 28px; padding: 0 9px; border-radius: 2px; background: var(--surface-1); color: var(--text-muted); font: 600 10px/1 var(--font-terminal); }
.chipActive { border-color: color-mix(in srgb, var(--terminal-green) 50%, var(--border)); background: var(--terminal-green-dim); color: var(--terminal-green); }

.metricGrid { display: grid; grid-template-columns: repeat(var(--metric-columns, 6), minmax(0, 1fr)); gap: 12px; }
.metricCard { position: relative; min-height: 108px; padding: 16px; }
.metricCard::before { content: ''; position: absolute; inset: 0 auto 0 0; width: 2px; display: block; background: var(--metric-accent); box-shadow: 0 0 12px color-mix(in srgb, var(--metric-accent) 35%, transparent); }
.metricLabel { color: var(--text-muted); font: 620 10px/1 var(--font-terminal); letter-spacing: .015em; }
.metricLabel::before { content: ':: '; color: var(--terminal-cyan); }
.metricValue { margin-top: 12px; color: var(--text-strong); font: 650 clamp(24px, 2.25vw, 32px)/1 var(--font-terminal); letter-spacing: -.04em; font-variant-numeric: tabular-nums; text-shadow: 0 0 14px rgb(237 247 242 / .055); }
.metricMeta { margin-top: 8px; color: var(--text-faint); font: 9px/1.45 var(--font-terminal); }
.deltaPositive { color: var(--success); }
.deltaNegative { color: var(--danger); }

.empty { min-height: 280px; padding: 38px 28px; display: grid; place-items: center; text-align: center; }
.empty > div { max-width: 540px; }
.emptyIcon { width: 44px; height: 44px; margin: 0 auto 14px; border: 1px solid var(--border); border-radius: 3px; background: var(--surface-2); color: var(--terminal-green); display: grid; place-items: center; }
.empty h2 { margin: 0; color: var(--text-strong); font: 650 16px/1.3 var(--font-terminal); }
.empty p { margin: 7px auto 17px; color: var(--text-muted); font-size: 12px; line-height: 1.6; }

.entity { min-width: 0; color: var(--text-strong); display: inline-flex; align-items: center; gap: 8px; }
.entityMark { width: 7px; height: 7px; flex: none; border-radius: 1px; background: var(--entity-color, var(--gold)); box-shadow: 0 0 7px color-mix(in srgb, var(--entity-color, var(--gold)) 40%, transparent); }
.entityAvatar { width: 22px; height: 22px; flex: none; border-radius: 2px; object-fit: cover; background: var(--surface-3); }
.entityText { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.mono { font-family: var(--font-mono); font-variant-numeric: tabular-nums; }

.status { min-height: 22px; padding: 0 7px; border: 1px solid color-mix(in srgb, currentColor 28%, transparent); border-radius: 2px; background: color-mix(in srgb, currentColor 7%, transparent); display: inline-flex; align-items: center; gap: 5px; font: 620 9px/1 var(--font-terminal); }
.status::before { content: ''; width: 5px; height: 5px; border-radius: 1px; background: currentColor; box-shadow: 0 0 6px currentColor; }
.statusGood { color: var(--success); }
.statusBad { color: var(--danger); }
.statusWarn { color: var(--warning); }
.statusNeutral { color: var(--text-muted); }

.notice { padding: 11px 13px; border: 1px solid var(--border); border-radius: var(--radius-md); background: var(--surface-2); color: var(--text-muted); display: flex; gap: 9px; font: 10px/1.5 var(--font-terminal); box-shadow: inset 2px 0 var(--warning); }
.notice svg { flex: none; color: var(--warning); margin-top: 1px; }
.field { min-width: 0; display: grid; gap: 6px; }
.fieldLabelRow, .dialogHeading { min-width: 0; display: flex; align-items: center; gap: 6px; }
.field label, .fieldLabel { color: var(--text-muted); font: 620 10px/1 var(--font-terminal); }
.fieldControlGroup { min-width: 0; }
.input, .select, .textarea { width: 100%; min-height: 36px; padding: 0 10px; border: 1px solid var(--border); border-radius: var(--radius-sm); background: #070c10; color: var(--text); caret-color: var(--terminal-green); font: 11px var(--font-terminal); outline: none; transition: border-color .12s ease, box-shadow .12s ease, background .12s ease; }
.textarea { min-height: 82px; padding: 9px 10px; resize: vertical; }
.input:hover, .select:hover, .textarea:hover { border-color: var(--border-strong); }
.input:focus, .select:focus, .textarea:focus { border-color: var(--terminal-green); box-shadow: 0 0 0 1px color-mix(in srgb, var(--terminal-green) 20%, transparent), inset 0 0 18px rgb(117 230 164 / .025); }

.dialogOverlay { position: fixed; inset: 0; z-index: 100; background: rgb(0 0 0 / .65); backdrop-filter: blur(4px); animation: fadeIn .12s ease; }
.dialogContent { position: fixed; left: 50%; top: 50%; z-index: 101; width: min(780px, calc(100vw - 24px)); max-height: min(820px, calc(100vh - 24px)); overflow: auto; transform: translate(-50%, -50%); border: 1px solid var(--border-strong); border-radius: var(--radius-xl); background: #0a1015; box-shadow: var(--shadow-overlay), inset 0 1px rgb(101 217 239 / .05); }
.dialogHeader { min-height: 58px; padding: 14px 16px; border-bottom: 1px solid var(--border-subtle); display: flex; align-items: flex-start; justify-content: space-between; gap: 14px; }
.dialogTitle { margin: 0; color: var(--text-strong); font: 650 15px/1.2 var(--font-terminal); letter-spacing: -.02em; }
.dialogTitle::before { content: '$ '; color: var(--terminal-green); }
.dialogBody { padding: 18px; }
.dialogFooter { position: sticky; bottom: 0; padding: 11px 16px; border-top: 1px solid var(--border-subtle); background: color-mix(in srgb, var(--surface-1) 94%, transparent); backdrop-filter: blur(10px); display: flex; justify-content: flex-end; gap: 7px; }

.infoTip { width: 18px; height: 18px; flex: none; padding: 0; border: 1px solid var(--border); border-radius: 2px; background: transparent; color: var(--text-faint); display: inline-grid; place-items: center; font: 700 9px/1 var(--font-mono); cursor: help; }
.infoTip span { display: contents; }
.infoTip:hover { border-color: var(--terminal-cyan); color: var(--terminal-cyan); }
.tooltip { z-index: 200; max-width: 320px; padding: 9px 10px; border: 1px solid var(--border-strong); border-radius: var(--radius-md); background: #091016; color: var(--text); box-shadow: var(--shadow-overlay), inset 2px 0 var(--terminal-cyan); font: 10px/1.5 var(--font-terminal); }
.visuallyHidden { position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip: rect(0, 0, 0, 0); white-space: nowrap; border: 0; }

@keyframes fadeIn { from { opacity: 0; } }

@media (max-width: 1180px) { .metricGrid { grid-template-columns: repeat(3, minmax(0, 1fr)); } }
@media (max-width: 700px) {
  .pageHeader { min-height: 0; display: grid; align-items: start; gap: 14px; }
  .pageActions { justify-content: flex-start; }
  .pageTitle { font-size: 22px; }
  .metricGrid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .metricCard { min-height: 102px; padding: 14px; }
  .metricValue { font-size: clamp(22px, 8vw, 29px); }
  .panelHeader { padding: 10px 13px; flex-direction: column; align-items: stretch; gap: 10px; }
  .panelBody { padding: 13px; }
  .button, .iconButton, .chip { min-height: 44px; }
  .iconButton { width: 44px; }
  .chip { padding-inline: 12px; }
  .input, .select { min-height: 44px; }
  .infoTip { width: 44px; height: 44px; margin: -9px; border: 0; background: transparent; }
  .infoTip span { width: 26px; height: 26px; border: 1px solid var(--border); border-radius: 2px; display: grid; place-items: center; }
  .infoTip:hover { border: 0; background: transparent; }
  .infoTip:hover span { border-color: var(--terminal-cyan); color: var(--terminal-cyan); }
  .dialogContent { inset: 0; width: 100vw; height: 100dvh; max-height: none; transform: none; border: 0; border-radius: 0; display: grid; grid-template-rows: auto minmax(0, 1fr) auto; overflow: hidden; }
  .dialogHeader { min-height: 64px; align-items: center; }
  .dialogBody { padding: 15px; overflow-y: auto; }
  .dialogFooter { position: static; padding-bottom: calc(11px + env(safe-area-inset-bottom)); }
}
